import C from 'utils/values/constant.util';

const NCOB_OFFSET_HOURS = C([
  { value: '01:00:00', description: '1', int: 1 },
  { value: '02:00:00', description: '2', int: 2 },
  { value: '03:00:00', description: '3', int: 3 },
  { value: '04:00:00', description: '4', int: 4 },
  { value: '05:00:00', description: '5', int: 5 },
  { value: '06:00:00', description: '6', int: 6 },
  { value: '07:00:00', description: '7', int: 7 },
  { value: '08:00:00', description: '8', int: 8 },
  { value: '09:00:00', description: '9', int: 9 },
  { value: '10:00:00', description: '10', int: 10 },
  { value: '11:00:00', description: '11', int: 11 },
  { value: '12:00:00', description: '12', int: 12 },
]);

export default NCOB_OFFSET_HOURS;
